import ElInput from './src/input';

export default ElInput;
